import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { Link } from 'gatsby'

import { content } from './international.content'
import PriceTable, {
  NotAvailable,
} from '../../../components/InternationalRoaming'
import PageHead from '../../../components/PageHead'
import {
  BreadCrumbs,
  Desktop,
  Mobile,
  SiteContainer,
  TopFlag,
} from '../../../components/shared'
import classes from '../../../components/shared/roaming.module.scss'
import withApp from '../../../components/withApp/withApp'
import { PAGE_CONSTANTS, MARITIME } from '../../../constants/globalStrings'

interface InternationalPageContext {
  display_country: string
  data: number | null
  back_to_uk: number | null
  back_to_uk_mobile: number | null
  back_to_uk_other: number | null
  local_roaming_fixed: number | null
  local_roaming_mobile: number | null
  local_roaming_other: number | null
  sms_rsn1_rseu: number | null
  inbound_calls: number | null
  mms_picture_rmn1: number | null
  iso_country_code: string
  iso_country_name_slug: string
}

interface InternationalProps {
  pageContext: InternationalPageContext
  location: { pathname: string }
}

const International: FC<InternationalProps> = ({
  pageContext: {
    display_country,
    data,
    back_to_uk,
    back_to_uk_mobile,
    back_to_uk_other,
    local_roaming_fixed,
    local_roaming_mobile,
    local_roaming_other,
    sms_rsn1_rseu,
    inbound_calls,
    mms_picture_rmn1,
    iso_country_code,
    iso_country_name_slug,
  },
}) => {
  const isRoamingNotAvailable = [
    data,
    back_to_uk,
    back_to_uk_mobile,
    back_to_uk_other,
    local_roaming_fixed,
    local_roaming_mobile,
    local_roaming_other,
    sms_rsn1_rseu,
    inbound_calls,
    mms_picture_rmn1,
  ].every((price) => price === null)

  return (
    <SiteContainer>
      <BreadCrumbs>
        <Desktop>
          <Link
            data-testid={PAGE_CONSTANTS.ROAMING.testId}
            to={PAGE_CONSTANTS.ROAMING.route}
          >
            {content.breadcrumbRoot}
          </Link>
          <Typography
            component="span"
            variant="Kollektif/Small"
            className={classes.navLink}
          >
            {'>'}
          </Typography>
          <Link
            data-testid={PAGE_CONSTANTS.ROAMING_INTERNATIONAL.testId}
            to={PAGE_CONSTANTS.ROAMING_INTERNATIONAL.route}
          >
            {content.breadcrumbCurrent}
          </Link>
          <Typography
            component="span"
            variant="Kollektif/Small"
            className={classes.navLink}
          >
            {'>'}
          </Typography>
          {display_country}
        </Desktop>
        <Mobile>
          {'< '}
          <Link to={PAGE_CONSTANTS.ROAMING_INTERNATIONAL.route}>
            {content.breadcrumbMobile}
          </Link>
        </Mobile>
      </BreadCrumbs>
      <TopFlag
        src={`/assets/images/flags/${iso_country_code.toLowerCase()}.${iso_country_name_slug === MARITIME ? 'svg' : 'png'}`}
        alt={iso_country_code}
        data-testid={`${iso_country_code}-flag`}
      />
      {isRoamingNotAvailable ? (
        <NotAvailable
          display_country={display_country}
          iso_country_name_slug={iso_country_name_slug}
        />
      ) : (
        <PriceTable
          display_country={display_country}
          iso_country_name_slug={iso_country_name_slug}
          data={data ?? undefined}
          back_to_uk={back_to_uk ?? undefined}
          back_to_uk_mobile={back_to_uk_mobile ?? undefined}
          back_to_uk_other={back_to_uk_other ?? undefined}
          local_roaming_fixed={local_roaming_fixed ?? undefined}
          local_roaming_mobile={local_roaming_mobile ?? undefined}
          local_roaming_other={local_roaming_other ?? undefined}
          sms_rsn1_rseu={sms_rsn1_rseu ?? undefined}
          inbound_calls={inbound_calls ?? undefined}
          mms_picture_rmn1={mms_picture_rmn1 ?? undefined}
        />
      )}
    </SiteContainer>
  )
}

export default withApp(International)

export const Head: FC<InternationalProps> = ({ pageContext, location }) => (
  <PageHead
    title={content.pageTitle(pageContext.display_country)}
    location={location}
  />
)
